<div #topLevel id="topLevel">
  <div
    #body
    id="body"
    [class.sidebar-collapsed]="
      isDesktop && (sidebarCollapseService.collapsed$ | async)
    "
  >
    <app-sidebar *ngIf="isLoggedIn$"></app-sidebar>

    <!-- ── Persistent mobile shell ─────────────────────────────────────── -->
    <!-- Header and footer live here permanently. The content slot (#shell-content)
         never changes size — only the routed content inside it swaps. -->
    <div id="shell" *ngIf="!isDesktop && isLoggedIn$">
      <app-header id="shell-header" [title]="shellTitle"></app-header>
      <div id="shell-content">
        <router-outlet></router-outlet>
      </div>
      <app-footer
        id="shell-footer"
        [featureBaseUrl]="featureBaseUrl"
      ></app-footer>
    </div>

    <!-- ── Desktop: no persistent shell, router-outlet fills the space ── -->
    <router-outlet *ngIf="isDesktop || !isLoggedIn$"></router-outlet>
  </div>
</div>
<div id="rotate-message">This application is best viewed in portrait mode.</div>

<!-- Global upgrade modal -->
<app-upgrade-modal
  [isVisible]="upgradeModalVisible"
  [featureName]="upgradeModalData?.featureName || 'Feature'"
  [currentVersion]="upgradeModalData?.currentVersion || ''"
  [newVersion]="upgradeModalData?.newVersion || ''"
  [isUpgrading]="upgradeModalIsUpgrading"
  (upgrade)="onUpgradeAccept()"
  (maybeLater)="onUpgradeDismiss()"
>
</app-upgrade-modal>
